import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit'
import authenticationsReducer from 'slices/authenticationsSlice'

export const store = configureStore({
  reducer: {
    authentications: authenticationsReducer,
  },
})

export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>
